import React from 'react'
import PropTypes from 'prop-types'
import VenueLayout from './layout'
import dynamic from 'next/dynamic'
import { GET_VENUE_DETAILS } from '@graphql/venue/venue.query'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import queryGraphql from '@shared/components/queryGraphql'
import { checkRedirectionStatus, handleApiError } from '@shared-submodule/utils'
import NoData from '@shared/components/noData'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
import Layout from '@shared/components/layout'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

// const GoogleAds = dynamic(() => import('@shared-submodule/sm-components/googleAds'), { ssr: false })
const KeyStatistics = dynamic(() => import('@shared/components/venueWidget/keyStatistics'))
const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

function VenueDetailPage({ venueData, seoData }) {
  const venueInfo = venueData?.getVenueDetailsById?.venue
  const { addTop } = reviveAdData
  return (
    <>
    <Layout
          data={{
            oSeo: {
              ...seoData?.getSeoData,
              sTitle: seoData?.getSeoData?.sTitle,
              sDescription: seoData?.getSeoData?.sDescription
            }
          }}
        >
      <VenueLayout>
        {venueData?.length === 0 ? <NoData title='This Venue’s a Ghost! Nothing here but tumbleweeds. Try another search to find your spot.'/> : (
          <section>
            <h1 className='my-2'>{venueInfo?.sName || ''}</h1>
            <p className="mb-4">
              {`${venueInfo?.sLocation || ''}${venueInfo?.sCountry ? `, ${venueInfo.sCountry}` : ''}`}
            </p>
            <div className="w-full d-none d-xl-flex justify-content-center ">
              {/* <GoogleAds
                addId={googleAddData?.addTop?.addId}
                divId={googleAddData?.addTop?.divId}
                dimension={googleAddData?.addTop?.dimension}
                slotId={googleAddData?.addTop?.slotId}
                className={'mb-3'}
              /> */}
              <ReviveAds {...addTop} className={'mb-3'}/>
            </div>
            <KeyStatistics venueDetails={venueData} />
          </section>
        )}
      </VenueLayout>
      </Layout>
    </>
  )
}

VenueDetailPage.propTypes = {
  venueData: PropTypes.object,
  seoData: PropTypes.object
}

export default VenueDetailPage

export async function getServerSideProps({ res, resolvedUrl, params }) {
  const slug = resolvedUrl
    .split('?')[0]
    .split('/')
    .filter(x => x)
  const mSlug = slug.join('/')
  try {
    res.setHeader('Cache-Control', 'public, max-age=7')
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: mSlug } })
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    const { data: venueData } = await queryGraphql(GET_VENUE_DETAILS, { input: { _id: seoData?.getSeoData.iId } })
    return { props: { venueData, seoData } }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
